// extracted by mini-css-extract-plugin
module.exports = {"buttons":"button_buttons__3--Ae","ghost":"button_ghost__1A-n4","groups":"button_groups__1jAMT"};